export default {
  REQUIRED_FIELD: "Champ requis",
  REQUIRED_POSITIVE_NUMBER: "Veuillez saisir un nombre positif",
  PERCENTAGE_MAX_100: "Le pourcentage doit être inférieur ou égal à 100",
};
